/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPhoneNumberDto
 */
export interface UserPhoneNumberDto {
    /**
     * User Id
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    userId?: string;
    /**
     * Country code of user's telephone number
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    countryCode?: string;
    /**
     * User's telephone number without country code
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    value?: string;
}

/**
 * Check if a given object implements the UserPhoneNumberDto interface.
 */
export function instanceOfUserPhoneNumberDto(value: object): boolean {
    return true;
}

export function UserPhoneNumberDtoFromJSON(json: any): UserPhoneNumberDto {
    return UserPhoneNumberDtoFromJSONTyped(json, false);
}

export function UserPhoneNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPhoneNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function UserPhoneNumberDtoToJSON(value?: UserPhoneNumberDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'countryCode': value['countryCode'],
        'value': value['value'],
    };
}

